import { Routes, Route, Navigate } from "react-router-dom";
import AppShell from "@/components/layout/AppShell";
import Dashboard from "@/pages/Dashboard";
import Findings from "@/pages/Findings";
import Audits from "@/pages/Audits";
import Investigations from "@/pages/Investigations";
import Reports from "@/pages/Reports";
import Alerts from "@/pages/Alerts";
import Incidents from "@/pages/Incidents";
import Devices from "@/pages/Devices";
import DeviceDetail from "@/pages/DeviceDetail";
import LiveData from "@/pages/LiveData";
import Settings from "@/pages/Settings";
import Login from "@/pages/Login";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />

        {/* Everything else lives behind ProtectedRoute. The shell + nested
            routes only mount once the user is loaded. */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index                   element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard"        element={<Dashboard />} />
          <Route path="findings"         element={<Findings />} />
          <Route path="audits"           element={<Audits />} />
          <Route path="investigations"   element={<Investigations />} />
          <Route path="reports"          element={<Reports />} />
          <Route path="alerts"           element={<Alerts />} />
          <Route path="incidents"        element={<Incidents />} />
          <Route path="devices"          element={<Devices />} />
          <Route path="devices/:id"      element={<DeviceDetail />} />
          <Route path="data"             element={<LiveData />} />
          <Route path="settings"         element={<Settings />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}
